/**
 * UNLEASH MAIN
 * const UNLEASH_URL = 'http://a2209265e0295413b894957f841d983f-113195905.ap-southeast-1.elb.amazonaws.com:4242'
 * const UNLEASH_API_KEY = '*:development.6f0962ed6373f762864074b11350aacebaac5ffbe04e96c9fe49fdc7'
 */

const UNLEASH_DEV = {
  url: 'https://us.app.unleash-hosted.com/usee0004/api/development/proxy',
  key: '2dnQ8v5t3HtmyRiWL2EMvhZZPpquCGCy'
}

const UNLEASH_PROD = {
  url: 'https://us.app.unleash-hosted.com/usee0004/api/production/proxy',
  key: 'wDLvPz6nxraRR0pr7OupTaTLiqdbh8Hs'
}

const SSG = 'orbit.circleslife.co'
const DSG = 'dsg-orbit.circleslife.co'

const unleashConfig = {
  url:
    window.location.hostname.includes('localhost') ||
    window.location.hostname.includes(SSG) ||
    window.location.hostname.includes(DSG)
      ? UNLEASH_DEV.url
      : UNLEASH_PROD.url,
  clientKey:
    window.location.hostname.includes('localhost') ||
    window.location.hostname.includes(SSG) ||
    window.location.hostname.includes(DSG)
      ? UNLEASH_DEV.key
      : UNLEASH_PROD.key,
  refreshInterval: 15,
  appName: 'orbit',
  environment:
    window.location.hostname.includes('localhost') ||
    window.location.hostname.includes(SSG) ||
    window.location.hostname.includes(DSG)
      ? 'development'
      : 'production'
}

export default unleashConfig
